import React, { ReactNode } from "react";
import { Flex } from "@UI/Components/Flex/Flex";
import { Bold } from "@UI/Components/Bold/Bold";

interface ItemLineProps {
  title: string | ReactNode;
  amount?: number | ReactNode;
  children?: ReactNode;
  isSubstract?: boolean;
  style?: React.CSSProperties;
}

export const ItemLine = ({
  title,
  amount,
  children,
  style,
  isSubstract,
}: ItemLineProps) => {
  return (
    <Flex
      pt={4}
      pb={4}
      flexDirection="column"
      borderTopWidth="1px"
      borderTopColor="gray.300"
      style={style}
    >
      <Flex justifyContent="space-between" flexGrow="1">
        <Flex>
          <Bold>{title}</Bold>
        </Flex>
        <Flex>
          {amount ? (
            <>
              {isSubstract && (
                <>
                  <Bold mr={1}>
                    <Flex>
                      {" - "}
                      {amount}
                    </Flex>
                  </Bold>
                </>
              )}
            </>
          ) : null}
        </Flex>
      </Flex>
      {children}
    </Flex>
  );
};
